const exp = (a) => (x) => Math.pow(x, a);

export default exp;
